import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Dropdown, Menu } from "antd";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import Slider from "react-slick";
import Breadcrumbs from "../../../components/Breadcrumbs";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import EmployeeLeaveModelPopup from "../../../components/modelpopup/EmployeeLeaveModelPopup";
import SearchBox from "../../../components/SearchBox";
import ReportingSelect from "../../../components/ReportingSelect";

const EmployeeLeave = () => {
  const [leaveData, setLeaveData] = useState([]);
  const [leaveStats, setLeaveStats] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(parseInt(localStorage.getItem("empid")));
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const dateFormat = localStorage.getItem("dateFormat") || "MMM DD, YYYY";
  const maximizeBtnRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [leaveToEdit, setLeaveToEdit] = useState(null);
  const [isFullScreen, setFullScreen] = useState(false);
  const leaveTypeSelectRef = useRef(null);
  const [viewMode, setViewMode] = useState(false); // Initialize view mode state

  const [selectedEmployeeId, setSelectedEmployeeId] = useState(parseInt(localStorage.getItem("empid")) || null);
  const [selectedEmployeeLabel, setSelectedEmployeeLabel] = useState(localStorage.getItem("empName") || null);


  const colors = [
    "#FFEEEE", "#EEFFEE", "#EEEEFF", "#FFFFEE", "#EEFFFF", "#FFEEFF",
    "#FFFAF0", "#F0FFF0", "#F0F0FF", "#FFFFF0", "#F0FFFF", "#FFF0FF"
  ];


  useEffect(() => {
    if (apiUrl && token) {
      fetchLeaveData(selectedEmployee);
      fetchLeaveStats(selectedEmployee); // This will be triggered on employee change
      fetchLeaveTypes();
    }
  }, [apiUrl, token, selectedEmployee]);
  

  const fetchLeaveData = async (empId) => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/leaves/list?empid=${empId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setLeaveData(response.data.leaves);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching leave data:", error);
    }
  };

  const fetchLeaveStats = async (empId) => {
    try {
      const response = await axios.get(`${apiUrl}/leaves/leave-balance-emp/${empId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const stats = response.data.leaveData;
      setLeaveStats(stats && stats.length > 0 ? stats : []);
    } catch (error) {
      console.error("Error fetching leave stats:", error);
      setLeaveStats([]);
    }
  };

const fetchLeaveTypes = async () => {
  try {
    const response = await axios.get(`${apiUrl}/leavetype/list?basic=true`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // Ensure response.data is an array before setting it
    if (Array.isArray(response.data)) {
      setLeaveTypes(response.data);
    } else {
      console.error("Unexpected response format for leave types:", response.data);
      setLeaveTypes([]); // Fallback to an empty array
    }
  } catch (error) {
    console.error("Error fetching leave types:", error);
    setLeaveTypes([]); // Fallback to an empty array in case of error
  }
};


  useEffect(() => {
    if (apiUrl && token) {
      fetchLeaveData(selectedEmployee);
      fetchLeaveStats(selectedEmployee);
      fetchLeaveTypes();
    }
  }, [apiUrl, token, selectedEmployee]);


  const handleEmployeeChange = async (selectedOption) => {
    if (selectedOption && selectedOption.value !='' ) {
     

    const selectedEmployeeId = selectedOption.value;
  
    setSelectedEmployeeId(selectedOption.value); // Set the selected employee ID
    setSelectedEmployeeLabel(selectedOption.label); // Set the selected employee label
  
    // Reset leave data to clear the previous employee's leaves
    setLeaveData([]); 
  
    // Fetch updated leave stats and leave data for the selected employee
    await fetchLeaveStats(selectedEmployeeId);
    await fetchLeaveData(selectedEmployeeId);
    }  else {
      // Show all employees if "Show All" is selected
      setSelectedEmployee(null);
      setSelectedEmployeeId(null);
    }
  };
  
  

  const handleEditClick = (record) => {

    setViewMode(false); // Assuming view mode
    setLeaveToEdit(record);
   // alert(viewMode);


  };

  const handleViewClick = (record) => {

    if (leaveTypeSelectRef.current) {
      leaveTypeSelectRef.current.reset();
    }
    setLeaveToEdit(record);
    setViewMode(true); // Assuming view mode

   // alert(viewMode);
    //alert("State changed");
  };
  


  const handleSave = (payload) => {
    setLeaveData((prevData) => {
      const leaveId = payload.leave_id;
      const leave_duration = payload.leave_duration;
      const leave_type_id = payload.leave_type_id;
  
      // Update the leave stats first
      const updatedLeaveStats = leaveStats.map((stat) => {
        if (stat.leave_type_id === leave_type_id) {
          return {
            ...stat,
            balance: stat.balance - leave_duration,
          };
        }
        return stat;
      });
  
      setLeaveStats(updatedLeaveStats);
  
      // Then, update the leave data
      if (leaveId) {
        const existingIndex = prevData.findIndex((leave) => leave.leave_id === leaveId);
        if (existingIndex !== -1) {
          const newData = [...prevData];
          newData[existingIndex] = payload;
          return newData;
        } else {
          return [...prevData, payload];
        }
      } else {
        return [...prevData, payload];
      }
    });
  };
  

  const handleAdd = () => {
    if (leaveTypeSelectRef.current) {
      leaveTypeSelectRef.current.reset();
    }
    setLeaveToEdit(null);
    setViewMode(false); // Assuming view mode

  };


  

  const handleUpdateStatus = async (leaveId, newStatus) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update the status of this leave?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });
  
    if (result.isConfirmed) {
      try {
        const response = await axios.put(`${apiUrl}/leaves/update-status/${leaveId}`, {
          status: newStatus,
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        
        const updatedLeave = response.data.leave;
  
        alert(newStatus);
        // Add debugging here
        console.log("Updating leave data with:", updatedLeave, newStatus);
  
        setLeaveData((prevData) => {
          const updatedData = prevData.map((leave) => {
            if (leave.leave_id === updatedLeave.leave_id) {
              console.log("Updating leave:", leave);
              return { ...leave, leave_status: newStatus, ...updatedLeave };
            }
            return leave;
          });
        
          console.log("Final updated data:", updatedData);
          return updatedData;
        });
        

  
        const { leave_type_id, leave_duration } = updatedLeave;
  
        setLeaveStats((prevStats) => {
          const updatedStats = prevStats.map((stat) => {
            if (stat.leave_type_id === leave_type_id) {
              return {
                ...stat,
                balance: stat.balance + leave_duration,
              };
            }
            return stat;
          });
  
          console.log("Updated leave stats:", updatedStats);
          return updatedStats;
        });

        
        toast.success("Leave status has been updated.");
      } catch (error) {
        let errorMessage = "Failed to update leave status. Please try again later.";
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        }
        Swal.fire("Error!", errorMessage, "error");
      }
    }
  };
  
  


  
 
  const handleDeleteClick = async (leaveId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this record",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${apiUrl}/leaves/delete/${leaveId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const { leave_type_id, leave_duration } = response.data.leave;

        const updatedLeaveStats = leaveStats.map(stat => {
          if (stat.leave_type_id === leave_type_id) {
            return {
              ...stat,
              balance: stat.balance + leave_duration
            };
          }
          return stat;
        });

        setLeaveStats(updatedLeaveStats);

        setLeaveData(leaveData.filter((leave) => leave.leave_id !== leaveId));

        toast.success("Leave request has been deleted.");
      } catch (error) {
        let errorMessage = "Failed to delete leaves. Please try again later.";
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        }
        Swal.fire("Error!", errorMessage, "error");
      }
    }
  };

  const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "", left: "-10px", zIndex: 1, top: "50%", transform: "translateY(-50%)",background:"tranprant" }}
        onClick={onClick}
      >

        <i className="fa fa-chevron-circle-left"  style={{ 
        display: "", 
        right: "-50px", 
        zIndex: 1, 
        top: "50%", 
        fontSize: "25px" // Adjust the size as needed
      }}></i>

      </div>
    );
  };
  
  const CustomNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "", right: "-10px", zIndex: 1, top: "50%", transform: "translateY(-50%)", content:""}}
        onClick={onClick}
      >
        <i className="fa fa-chevron-circle-right"  style={{ 
        display: "", 
        right: "-50px", 
        zIndex: 1, 
        top: "50%", 
        fontSize: "25px" // Adjust the size as needed
      }}></i>
      </div>
    );
  };
  
  
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    marginRight: 10,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  };
  

  const columns = [
    {
      title: "Leave Type",
      dataIndex: "leave_type_id",
      render: (leaveTypeId, record) => {
        const leaveType = leaveTypes.find(type => type.leave_type_id === leaveTypeId);
    
        return (
          <a
            href="#"
            onClick={() => handleViewClick(record)} // Bind onClick event here
            data-bs-toggle="modal"
            data-bs-target="#add_leave"
          >
            {leaveType ? leaveType.leavetypename : "Unknown"}
          </a>
        );
      }
  
    
    },
    {
      title: "From",
      dataIndex: "leave_start_date",
      sorter: (a, b) => moment(a.leave_start_date).unix() - moment(b.leave_start_date).unix(),
      render: (date) => moment(date).format(dateFormat),
    },
    {
      title: "To",
      dataIndex: "leave_end_date",
      sorter: (a, b) => moment(a.leave_end_date).unix() - moment(b.leave_end_date).unix(),
      render: (date) => moment(date).format(dateFormat),
    },
    {
      title: "No of Days",
      dataIndex: "leave_duration",
      sorter: (a, b) => a.leave_duration - b.leave_duration,
    },
    {
      title: "Requested On",
      dataIndex: "created_at",
      sorter: (a, b) => moment(a.created_at).unix() - moment(b.created_at).unix(),
      render: (date) => moment(date).format(dateFormat),
    },
    	
    {
      title: "Reason",
      dataIndex: "leave_reason",
    },
    {
      title: "Status",
      dataIndex: "leave_status",
      render: (status) => (
        <span
          className={`badge badge-custom ${status === '1' ? "bg-success" : status === '2' ? "bg-warning" : status === '3' ? "bg-danger" : "bg-info"}`}
        >
          {status === '1' ? "Approved" : status === '0'  ? "Pending" : status === '3' ? "Cancelled" : status === '2' ? "Rejected" : "Unknown"}
        </span>
      ),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="edit" onClick={() => handleEditClick(record)} data-bs-toggle="modal" data-bs-target="#add_leave">
                <Link to="#">
                  <i className="fa fa-pencil m-r-5" /> Edit
                </Link>
              </Menu.Item>


              <Menu.Item key="delete" onClick={() => handleDeleteClick(record.leave_id)}>
                <span>
                  <i className="fa fa-trash m-r-5" /> Delete
                </span>
              </Menu.Item>
              <Menu.Item key="update-status" onClick={() => handleUpdateStatus(record.leave_id, 3)}>
                <span>
                  <i className="fa fa-ban m-r-5" /> Cancel
                </span>
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
          placement="bottomRight"
        >
          <Link to="#" className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
            <i className="material-icons">more_vert</i>
          </Link>
        </Dropdown>
      ),
    },
  ];



  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
        <div className="page-header page-top-icons">
        <div className="row align-items-center">
              <div className="col-md-4">
                <ReportingSelect
  value={selectedEmployeeId ? { value: selectedEmployeeId, label: selectedEmployeeLabel } : null}
  onChange={handleEmployeeChange}
/>

              </div>
              <div className="col-md-8 float-end ms-auto">
                <div className="d-flex title-head">
                  <div className="view-icons">
                    <Link to="#" className="grid-view btn btn-link"><i className="las la-redo-alt" /></Link>
                    <Link to="#" className="list-view btn btn-link" id="collapse-header" ref={maximizeBtnRef}><i className="las la-expand-arrows-alt" /></Link>
                  </div>
                  <Link to="#" className="btn custom-btn" data-bs-toggle="modal" data-bs-target="#add_leave" onClick={handleAdd}>
  <i className="la la-plus-circle custom-icon" /> Apply Leave
</Link>


                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-12 col-md-12 d-flex">
            <div className="card flex-fill">
              <div className="card-body" style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>

                <div className="row align-items-center">
                  <div className="col-sm-12">
                  <Slider {...settings} className="company-slider">
                    {leaveStats.length > 0 ? (
                      leaveStats.map((stat, index) => (
                        <div key={index} className="owl-item active" style={{ width: '199.667px', marginRight: '20px' }}>
                          <div
                              className="company-grid company-soft-tertiary"
                              style={{
                                backgroundColor: colors[index % colors.length],
                                border: '1px solid rgba(0, 0, 0, 0.05)',
                                borderRadius: '10px', // Rounded corners
                                 // Very light color border
                              }}
                            >

                            <div className="company-top">
                              <div className="company-icon">
                                <span className="company-icon-tertiary rounded-circle">
                                  {stat.code}
                                </span>
                              </div>
                              <div className="company-link">
                                <h4>{stat.type}</h4>
                                <p>{stat.balance}</p>
                              </div>
                            </div>
                            <div className="company-bottom d-flex">
                              <div className="company-bottom-links">
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div>No leave statistics available</div>
                    )}
              </Slider>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {loading ? (
                <div id="loader-wrapper-">
                  <div className="loader">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                </div>
              ) : leaveData.length === 0 ? (
                <div className="no-data-container">
                  <img 
                    src="https://netshine-assets.blr1.cdn.digitaloceanspaces.com/app-assets/empty-data.svg" 
                    alt="No data available" 
                  />
                  <h3>No Data Available</h3>
                  <p>There are no leave applications to display right now.</p>
                </div>
              ) : (

                <div className="table-responsive">
                  <Table
                    columns={columns}
                    dataSource={leaveData}
                    rowKey="leave_id"
                    className="table-striped"
                    pagination={{ pageSize: 20 }}  // Set default page size to 25

                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <EmployeeLeaveModelPopup 
    onSave={handleSave} 
    leaveData={leaveToEdit} 
    leaveStats={leaveStats} 
    viewMode={viewMode} 
    setLeaveData={setLeaveData} 
    setLeaveStats={setLeaveStats} 
  />

    </>
  );
};

export default EmployeeLeave;
